import styled from 'styled-components';

export default styled.div`
  && {
    .backToScreenPrev {
      padding-left: 65px;
      background-color: rgba(193, 225, 141, 1);
      height: 30px;
    }
    .headerMini {
      background-color: rgba(236, 255, 184, 1);
      padding: 0 65px;
    }
    .ml-15px {
      margin-left: 15px;
    }
    .cpap-body {
      position: relative;
      .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        background: rgba(255, 255, 255, 0.8);
      }
    }
    .section {
      padding: 55px 65px;
      background-color: white;
      .largeBox {
        .content1 {
          margin-bottom: 20px;
          border: 1px solid #dddddd;
          padding: 12px 1px;
        }
        .content2 {
          border: 1px solid #dddddd;
          margin-bottom: 20px;
          padding: 20px 40px 20px 1px;
        }
        box-shadow: 0 1px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        .box {
          border-top: 1px solid #dddddd;
          padding: 25px;
          .patient-name {
            font-family: Hiragino Kaku Gothic Pro;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 24px;
            color: #000000;
          }
        }
      }
    }
    .mr-15 {
      margin-right: 15px;
    }
    .mh-10 {
      margin: 0 10px;
    }
    .mt-40 {
      margin-top: 40px;
    }
    .ml-8 {
      margin-left: 8px;
    }
    .l {
      border-right: 0.5px solid #000000;
      height: 30px;
      margin: 0 10px;
    }
    .border-bt {
      border-bottom: 1px solid #dddddd;
    }
    .accessories-disable {
      font-family: Hiragino Kaku Gothic Pro;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 21px;
      color: #d8d8d8;
    }
    @media screen and (max-width: 844px) {
      .backToScreenPrev,
      .headerMini {
        padding: 0 10px;
      }
      .section {
        padding: 20px 10px 40px;
        > .ant-row {
          display: block;
          > .ant-col {
            width: 100%;
            max-width: 100%;
            margin: 0 0 10px;
          }
        }
        .box {
          .ant-row {
            .smallFont,
            > .ant-col:not(:first-child),
            > .ant-col:not(:first-child) .standardFont,
            > .ant-col:not(:first-child) .standardBoldFont {
              font-size: 16px;
              line-height: 1.4;
            }
          }
        }
        .largeBox .box {
          padding: 25px 10px;
          .content1,
          .content2 {
            display: block;
            margin-bottom: 10px;
            padding: 5px;
            border-top: none;
            border-right: none;
            border-left: none;
            div {
              width: 100%;
              max-width: 100%;
            }
            > div {
              &:not(.standardBoldFont) {
                padding: 10px;
              }
            }
            .ant-row,
            .d-flex {
              display: block;
              p {
                display: inline-block;
              }
              .bar {
                height: 1px;
                margin: 0;
                border: none;
                display: block;
              }
            }
          }
          > div:nth-child(2) {
            > div:nth-child(2) > div > div {
              display: inline-block;
              width: auto;
              padding-right: 5px;
              &:nth-child(3)::before {
                content: '　/　';
              }
              &:nth-child(3)::after {
                content: '：';
              }
            }
          }
          > div:nth-child(3) {
            > div:nth-child(2) > div > div {
              display: inline-block;
              width: auto;
              &:nth-child(3)::before {
                content: '　/　';
              }
              padding-right: 5px;
              .l {
                display: none;
              }
            }
          }
          > div:nth-child(4) {
            > div:not(:first-child) {
              padding: 10px;
            }
            .space2 {
              display: none;
            }
          }
        }
      }
    }
  }
`;
